export default function SkeletonCard() {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="w-full animate-pulse aspect-[3/4] bg-background-200" />
      <div className="space-y-2 p-3">
        <div className="h-4 w-3/4 animate-pulse rounded bg-background-200" />
        <div className="h-3 w-1/2 animate-pulse rounded bg-background-200" />
        <div className="h-3 w-full animate-pulse rounded bg-background-200" />
      </div>
    </div>
  );
}